import React, { useState, useEffect, useRef } from "react";
import { Container, Card, Form, Button, Row, Col } from "react-bootstrap";
import { FaFilePdf, FaFileAlt, FaImage, FaTimes } from "react-icons/fa";
import {
    getBookingHistoryDetail,
    getYachtAction,
} from "../../../redux/booking/BookingSlice";
import { sendRefundRequestEmailAction } from "../../../redux/Auth/AuthSlice";
import { useSelector, useDispatch } from "react-redux";
import ConfirmedBg from "../../../Asset/image/yacht/ConfirmedBg.png";
import RefundIcon from "../../../Asset/image/yacht/Comfirmed.svg";
import { Snackbar, Alert } from "@mui/material";
import SendRoundedIcon from "@mui/icons-material/SendRounded";
import LogoTMY from "../../../Asset/image/home/logo_Sail.png";

import "./RefundRequest.css";

function RefundRequest() {
    const dispatch = useDispatch();

    const todos = useSelector((state) => state);

    const getToken = useSelector((state) => state.AuthSlice.token);

    const [formData, setFormData] = useState({
        bookingNumber: "",
        requestType: "refund",
        contactName: "",
        email: "",
        reason: "",
        attachments: [],
    });

    const [previewFiles, setPreviewFiles] = useState([]);

    const [snackbar, setSnackbar] = useState({
        open: false,
        message: "",
        severity: "success",
    });

    const fileInputRef = useRef(null);

    const handleCloseSnackbar = () => {
        setSnackbar((prev) => ({
            ...prev,
            open: false,
        }));
    };

    const toBase64 = (file) =>
        new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = reject;
        });

    useEffect(() => {
        const fetchData = async () => {
            await Promise.all([
                dispatch(getBookingHistoryDetail({ token: getToken })),
                dispatch(getYachtAction({})),
            ]);
        };

        if (getToken) {
            fetchData();
        }
    }, [dispatch, getToken]);

    const handleChange = (e) => {
        const { name, value, files } = e.target;

        if (files) {
            const newFiles = Array.from(files);

            setFormData((prev) => ({
                ...prev,
                attachments: [...prev.attachments, ...newFiles],
            }));

            const previews = newFiles.map((file) => ({
                file,
                type: file.type.startsWith("image/")
                    ? "image"
                    : file.type === "application/pdf"
                        ? "pdf"
                        : "file",
                url: file.type.startsWith("image/") ? URL.createObjectURL(file) : null,
            }));

            setPreviewFiles((prev) => [...prev, ...previews]);
        } else {
            setFormData((prev) => ({
                ...prev,
                [name]: value,
            }));
        }
    };

    const removeFile = (index) => {
        setPreviewFiles((prev) => {
            const file = prev[index];

            // ป้องกัน Memory Leak
            if (file.url) {
                URL.revokeObjectURL(file.url);
            }

            return prev.filter((_, i) => i !== index);
        });

        setFormData((prev) => ({
            ...prev,
            attachments: prev.attachments.filter((_, i) => i !== index),
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const bookingHistory = todos?.Booking?.BookingHistroy
            ?.results || [];

        const booking = bookingHistory.find(
            (item) => item.booking_no === formData.bookingNumber,
        );

        const yachtOwnerData = todos?.Booking?.yachtResult?.data?.find(
            (item) => Number(item.id_yacht) === Number(booking.id_yacht),
        );

        console.log("bookingHistory", todos);

        if (!yachtOwnerData) {
            setSnackbar({
                open: true,
                message: "Yacht not found.",
                severity: "error",
            });
            return;
        }

        const yachtOwnerEmail = yachtOwnerData?.email;

        if (!yachtOwnerEmail) {
            setSnackbar({
                open: true,
                message: "Yacht owner's email not found.",
                severity: "error",
            });
            return;
        }

        const attachmentsBase64 = await Promise.all(
            formData.attachments.map(async (file) => ({
                name: file.name,
                type: file.type,
                data: await toBase64(file),
            }))
        );

        const requestTypeLabel = {
            refund: "ขอคืนเงิน Refund Request",
            access: "ขอเข้าถึงข้อมูล Access Request",
            rectification: "ขอแก้ไขข้อมูล Rectification",
            erasure: "ขอลบข้อมูล Erasure",
            portability: "ขอโอนย้ายข้อมูล Portability",
            object: "คัดค้านการประมวลผล Object",
            withdraw: "ถอนความยินยอม Withdraw Consent",
        };

        const imageUrlToBase64 = async (url) => {
            const response = await fetch(url);
            const blob = await response.blob();

            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.readAsDataURL(blob);
                reader.onloadend = () => resolve(reader.result);
                reader.onerror = reject;
            });
        };

        const logoBase64 = await imageUrlToBase64(LogoTMY);

        const emailData = {
            recipient: yachtOwnerData.email,
            dear: yachtOwnerData.name_yacht,
            subject: `[Data Rights Request] ${requestTypeLabel[formData.requestType]} | ${formData.contactName}`,

            bookingNumber: formData.bookingNumber,
            requestType: requestTypeLabel[formData.requestType],
            contactName: formData.contactName,
            email: formData.email,
            reason: formData.reason,
            logo: {
                name: "logo.png",
                data: logoBase64
            },
            attachments: attachmentsBase64,
        };



        try {
            await dispatch(sendRefundRequestEmailAction(emailData));

            setSnackbar({
                open: true,
                message: "Refund request submitted successfully.",
                severity: "success",
            });

            // ล้าง Object URL
            previewFiles.forEach((item) => {
                if (item.url) {
                    URL.revokeObjectURL(item.url);
                }
            });

            // รีเซ็ตข้อมูลฟอร์ม
            setFormData({
                bookingNumber: "",
                requestType: "access",
                reason: "",
                contactName: "",
                email: "",
                attachments: [],
            });

            // รีเซ็ต Preview
            setPreviewFiles([]);

            // รีเซ็ต input file
            if (fileInputRef.current) {
                fileInputRef.current.value = "";
            }
        } catch (error) {
            setSnackbar({
                open: true,
                message: "Failed to submit refund request.",
                severity: "error",
            });
        }
    };

    return (
        <div
            className="refund-page"
            style={{
                backgroundImage: `url(${ConfirmedBg})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                minHeight: "100vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "flex-start",
                padding: "5px 5px",
            }}
        >
            <Container fluid={false}
                style={{
                    display: "flex",
                    justifyContent: "center",
                    width: "100%",
                }}>
                <Card className="refund-card"
                    style={{
                        width: "100%",
                        maxWidth: "760px",
                        border: "none",
                        borderRadius: "28px",
                        boxShadow: "0 20px 50px rgba(0,0,0,.08)",
                        overflow: "hidden",
                        background: "#fff",
                        margin: "40px"
                    }}>

                    <Card.Body className="p-4 p-md-5">

                        <div className="request-badge"
                            style={{
                                display: "inline-flex",
                                alignItems: "center",
                                padding: "6px 16px",
                                borderRadius: "999px",
                                background: "#EDF4FF",
                                color: "#2E5BFF",
                                fontSize: "13px",
                                marginBottom: "18px",
                                fontWeight: 500,
                            }}>
                            <span>🛡️ Data Rights Request</span>
                        </div>

                        <h1 className="request-title">
                            คำขอใช้สิทธิข้อมูลส่วนบุคคล
                        </h1>

                        <p className="request-description">
                            ภายใต้ PDPA และ GDPR คุณสามารถใช้สิทธิ์เกี่ยวกับข้อมูลส่วนบุคคลของคุณ
                            กรุณากรอกแบบฟอร์มด้านล่างเพื่อส่งคำขอ
                        </p>

                        <Form onSubmit={handleSubmit}>

                            <Row>
                                <Col md={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>ชื่อ-สกุล *</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="contactName"
                                            value={formData.contactName}
                                            onChange={handleChange}
                                            placeholder="ชื่อ นามสกุล"
                                            required
                                            style={{
                                                borderRadius: "14px",
                                                height: "54px",
                                                border: "1px solid #DCE3EF",
                                                boxShadow: "none",
                                            }}
                                        />
                                    </Form.Group>
                                </Col>

                                <Col md={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>อีเมล *</Form.Label>
                                        <Form.Control
                                            type="email"
                                            name="email"
                                            value={formData.email}
                                            onChange={handleChange}
                                            placeholder="you@email.com"
                                            required
                                            style={{
                                                borderRadius: "14px",
                                                height: "54px",
                                                border: "1px solid #DCE3EF",
                                                boxShadow: "none",
                                            }}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>

                            <Row>
                                <Form.Group className="mb-3">
                                    <Form.Label>หมายเลขการจอง *</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="bookingNumber"
                                        value={formData.bookingNumber}
                                        onChange={handleChange}
                                        placeholder="เช่น BK202600001"
                                        required
                                        style={{
                                            borderRadius: "14px",
                                            height: "54px",
                                            border: "1px solid #DCE3EF",
                                            boxShadow: "none",
                                        }}
                                    />
                                </Form.Group>
                            </Row>

                            <Form.Group className="mb-3">
                                <Form.Label>ประเภทคำขอ</Form.Label>
                                <Form.Select
                                    name="requestType"
                                    value={formData.requestType}
                                    onChange={handleChange}
                                >
                                    <option value="refund">ขอคืนเงิน (Refund)</option>
                                    <option value="access">ขอเข้าถึงข้อมูล (Access)</option>
                                    <option value="rectification">ขอแก้ไขข้อมูล (Rectification)</option>
                                    <option value="erasure">ขอลบข้อมูล (Erasure)</option>
                                    <option value="portability">ขอโอนย้ายข้อมูล (Portability)</option>
                                    <option value="object">คัดค้านการประมวลผล (Object)</option>
                                    <option value="withdraw">ถอนความยินยอม (Withdraw Consent)</option>
                                </Form.Select>
                            </Form.Group>

                            <Form.Group className="mb-4">
                                <Form.Label>รายละเอียดเพิ่มเติม</Form.Label>

                                <textarea
                                    className="form-control"
                                    rows={5}
                                    name="reason"
                                    value={formData.reason}
                                    onChange={handleChange}
                                    placeholder="ระบุรายละเอียด..."
                                    required
                                    style={{
                                        borderRadius: "14px",
                                        minHeight: "150px",
                                        border: "1px solid #DCE3EF",
                                        resize: "vertical",
                                    }}
                                />
                            </Form.Group>

                            {/* Upload File เดิม */}

                            <Form.Group className="mb-4">
                                <Form.Label>แนบไฟล์ประกอบ</Form.Label>

                                <div className="upload-box">

                                    <input
                                        ref={fileInputRef}
                                        id="attachment"
                                        type="file"
                                        multiple
                                        accept=".jpg,.jpeg,.png,.pdf"
                                        hidden
                                        onChange={handleChange}
                                    />

                                    <label htmlFor="attachment" className="upload-preview">

                                        {previewFiles.length > 0 ? (

                                            <>
                                                <div className="preview-list">

                                                    {previewFiles.map((item, index) => (

                                                        <div className="preview-item" key={index}>

                                                            <button
                                                                type="button"
                                                                className="remove-file-btn"
                                                                onClick={(e) => {
                                                                    e.preventDefault();
                                                                    e.stopPropagation();
                                                                    removeFile(index);
                                                                }}
                                                            >
                                                                <FaTimes />
                                                            </button>

                                                            {item.type === "image" && (
                                                                <img
                                                                    src={item.url}
                                                                    className="preview-image"
                                                                    alt=""
                                                                />
                                                            )}

                                                            {item.type === "pdf" && (
                                                                <FaFilePdf className="preview-file-icon pdf-icon" />
                                                            )}

                                                            {item.type === "file" && (
                                                                <FaFileAlt className="preview-file-icon" />
                                                            )}

                                                            <div className="selected-file">
                                                                {item.file.name}
                                                            </div>

                                                        </div>

                                                    ))}

                                                </div>

                                                <label
                                                    htmlFor="attachment"
                                                    className="upload-button"
                                                >
                                                    + เพิ่มไฟล์
                                                </label>

                                            </>

                                        ) : (

                                            <label
                                                htmlFor="attachment"
                                                className="upload-button"
                                            >
                                                📎 เลือกไฟล์
                                            </label>

                                        )}

                                    </label>

                                </div>

                            </Form.Group>

                            <Button
                                type="submit"
                                style={{
                                    background: "linear-gradient(90deg,#2748D8,#29C7E9)",
                                    border: "none",
                                    borderRadius: "40px",
                                    padding: "13px 32px",
                                    fontWeight: 600,
                                    boxShadow: "0 10px 25px rgba(39,72,216,.25)",
                                }}
                            >
                                <SendRoundedIcon
                                    sx={{
                                        mb: 0.5,
                                        mr: 1,
                                        fontSize: 18,
                                    }}
                                />
                                ส่งคำขอ
                            </Button>

                        </Form>
                    </Card.Body>
                </Card>
            </Container>

            <Snackbar
                open={snackbar.open}
                autoHideDuration={4000}
                onClose={handleCloseSnackbar}
                anchorOrigin={{
                    vertical: "top",
                    horizontal: "center",
                }}
            >
                <Alert
                    severity={snackbar.severity}
                    onClose={handleCloseSnackbar}
                    variant="filled"
                    elevation={6}
                    sx={{
                        borderRadius: "12px",
                        minWidth: 350,
                    }}
                >
                    {snackbar.message}
                </Alert>
            </Snackbar>
        </div>
    );
}

export default RefundRequest;
